import React from 'react';
import {
  Container,
  Content,
  Title,
  Subtitle,
  Header,
  HeaderGradient,
  HeaderLogo,
  HeaderTitle,
} from './styles';
import { E_LOGO_WHITE } from '../../constants/images';

const GiftCardTimeout = () => {
  return (
    <Container>
      <Header>
        <HeaderGradient>
          <HeaderLogo src={E_LOGO_WHITE} alt='Eternal Logo' />
          <HeaderTitle>Happy Diwali from all of us at Eternal</HeaderTitle>
        </HeaderGradient>
      </Header>
      <Content>
        <Title>Gift Card Creation is under process...</Title>
        <Subtitle>
          You will get email notification once it&apos;s done.
        </Subtitle>
      </Content>
    </Container>
  );
};

export default GiftCardTimeout;
